import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export function CreateTeamDialog({ gameId, onSuccess }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [airlineCode, setAirlineCode] = useState("");
  const [creating, setCreating] = useState(false);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!gameId) return;
    
    setCreating(true);

    try {
      const response = await axios.post(`${API}/games/${gameId}/teams`, {
        name,
        airline_code: airlineCode
      });
      onSuccess(response.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to create team");
    } finally {
      setCreating(false);
    }
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t("instructor.createTeam")}</DialogTitle>
        <DialogDescription>Add an airline team to the simulation</DialogDescription>
      </DialogHeader>
      <form onSubmit={handleCreate} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label htmlFor="teamName">{t("instructor.teamName")}</Label>
          <Input
            id="teamName"
            placeholder="Blue Sky Airlines"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            data-testid="team-name-input"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="code">{t("instructor.airlineCode")}</Label>
          <Input
            id="code"
            placeholder="BSA"
            value={airlineCode}
            onChange={(e) => setAirlineCode(e.target.value.toUpperCase())}
            required
            maxLength={3}
            minLength={2}
            data-testid="airline-code-input"
          />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button type="submit" disabled={creating} data-testid="create-team-submit">
            {creating ? t("common.loading") : t("instructor.createTeam")}
          </Button>
        </div>
      </form>
    </>
  );
}
